import { render, staticRenderFns } from "./TabelaAdministracao.vue?vue&type=template&id=5b11e908"
import script from "./TabelaAdministracao.vue?vue&type=script&lang=js"
export * from "./TabelaAdministracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports